import React, { FC } from 'react'
import {
    EuiTitle,
    EuiText,
    EuiSpacer
} from '@elastic/eui'
import { Persona } from 'api/entities/Persona'
import PersonaInfo from './PersonaInfo'

export interface PersonaDetailsProps {
    persona: Persona
}

const PersonaDetails: FC<PersonaDetailsProps> = ({ persona }) => {
    return (
        <>
            <EuiSpacer size="l" />

            <PersonaInfo
                demographics={persona.demographics}
                triggers={persona.triggers}
                barriers={persona.barriers}
            />
        </>
    )
}

export default PersonaDetails 